// actions

export { default as AddIcon } from './actions/AddIcon';
export { default as ChatIcon } from './actions/ChatIcon';
export { default as CloseIcon } from './actions/CloseIcon';
export { default as ComposeIcon } from './actions/ComposeIcon';
export { default as ComprehensionCheckIcon } from './actions/ComprehensionCheckIcon';
export { default as ContextualHelpIcon } from './actions/ContextualHelpIcon';
export { default as CopyIcon } from './actions/CopyIcon';
export { default as DownloadIcon } from './actions/DownloadIcon';
export { default as DragHandleIcon } from './actions/DragHandleIcon';
export { default as EditIcon } from './actions/EditIcon';
export { default as EmailIcon } from './actions/EmailIcon';
export { default as EyeIcon } from './actions/EyeIcon';
export { default as EyeHiddenIcon } from './actions/EyeHiddenIcon';
export { default as HistoryIcon } from './actions/HistoryIcon';
export { default as MaximizeIcon } from './actions/MaximizeIcon';
export { default as MinimizeIcon } from './actions/MinimizeIcon';
export { default as NewChatIcon } from './actions/NewChatIcon';
export { default as RaiseHandIcon } from './actions/RaiseHandIcon';
export { default as RedoIcon } from './actions/RedoIcon';
export { default as ReloadIcon } from './actions/ReloadIcon';
export { default as RemoveIcon } from './actions/RemoveIcon';
export { default as ReplyIcon } from './actions/ReplyIcon';
export { default as SendIcon } from './actions/SendIcon';
export { default as ShareIcon } from './actions/ShareIcon';
export { default as SwapIcon } from './actions/SwapIcon';
export { default as SwitcherIcon } from './actions/SwitcherIcon';
export { default as TrashIcon } from './actions/TrashIcon';
export { default as UndoIcon } from './actions/UndoIcon';
export { default as UploadIcon } from './actions/UploadIcon';
export { default as VersionHistoryIcon } from './actions/VersionHistoryIcon';
export { default as ZoomInIcon } from './actions/ZoomInIcon';
export { default as ZoomOutIcon } from './actions/ZoomOutIcon';

// content

export { default as AchievementIcon } from './content/AchievementIcon';
export { default as ArtIcon } from './content/ArtIcon';
export { default as AuthIcon } from './content/AuthIcon';
export { default as BriefcaseIcon } from './content/BriefcaseIcon';
export { default as CalendarIcon } from './content/CalendarIcon';
export { default as CartIcon } from './content/CartIcon';
export { default as CashIcon } from './content/CashIcon';
export { default as CheckIcon } from './content/CheckIcon';
export { default as ClockOutlineIcon } from './content/ClockOutlineIcon';
export { default as CollectionIcon } from './content/CollectionIcon';
export { default as GiftIcon } from './content/GiftIcon';
export { default as HealthIcon } from './content/HealthIcon';
export { default as KeyboardIcon } from './content/KeyboardIcon';
export { default as LaptopIcon } from './content/LaptopIcon';
export { default as LaunchIcon } from './content/LaunchIcon';
export { default as LocationIcon } from './content/LocationIcon';
export { default as LockIcon } from './content/LockIcon';
export { default as MathIcon } from './content/MathIcon';
export { default as MegaphoneIcon } from './content/MegaphoneIcon';
export { default as MembersIcon } from './content/MembersIcon';
export { default as PhoneIcon } from './content/PhoneIcon';
export { default as ScienceIcon } from './content/ScienceIcon';
export { default as SecureIcon } from './content/SecureIcon';
export { default as StopwatchIcon } from './content/StopwatchIcon';
export { default as TargetIcon } from './content/TargetIcon';
export { default as TrendingIcon } from './content/TrendingIcon';
export { default as TrophyIcon } from './content/TrophyIcon';
export { default as UnlockIcon } from './content/UnlockIcon';
export { default as UserIcon } from './content/UserIcon';
export { default as YellowStarIcon } from './content/YellowStarIcon';

// direction

export { default as ArrowDownIcon } from './direction/ArrowDownIcon';
export { default as ArrowNextIcon } from './direction/ArrowNextIcon';
export { default as ArrowPreviousIcon } from './direction/ArrowPreviousIcon';
export { default as ArrowUpIcon } from './direction/ArrowUpIcon';
export { default as ChevronDownIcon } from './direction/ChevronDownIcon';
export { default as ChevronNextIcon } from './direction/ChevronNextIcon';
export { default as ChevronPreviousIcon } from './direction/ChevronPreviousIcon';
export { default as ChevronUpIcon } from './direction/ChevronUpIcon';

// learning

export { default as AnswerCorrectIcon } from './learning/AnswerCorrectIcon';
export { default as AnswerWrongIcon } from './learning/AnswerWrongIcon';
export { default as AssignmentIcon } from './learning/AssignmentIcon';
export { default as CertificateIcon } from './learning/CertificateIcon';
export { default as CurriculumIcon } from './learning/CurriculumIcon';
export { default as DegreeIcon } from './learning/DegreeIcon';
export { default as DialogueIcon } from './learning/DialogueIcon';
export { default as DiscussionPromptIcon } from './learning/DiscussionPromptIcon';
export { default as GradingIcon } from './learning/GradingIcon';
export { default as HonorsAssignmentIcon } from './learning/HonorsAssignmentIcon';
export { default as InstitutionIcon } from './learning/InstitutionIcon';
export { default as InstructorIcon } from './learning/InstructorIcon';
export { default as LTIIcon } from './learning/LTIIcon';
export { default as NoteIcon } from './learning/NoteIcon';
export { default as ProgrammingAssignmentIcon } from './learning/ProgrammingAssignmentIcon';
export { default as QuizIcon } from './learning/QuizIcon';
export { default as ReadingIcon } from './learning/ReadingIcon';
export { default as ReviewIcon } from './learning/ReviewIcon';
export { default as SlideshowIcon } from './learning/SlideshowIcon';
export { default as StaffGradedIcon } from './learning/StaffGradedIcon';
export { default as VideoIcon } from './learning/VideoIcon';
export { default as WebIcon } from './learning/WebIcon';

// learning_circled

export { default as AssignmentCircledIcon } from './learning_circled/AssignmentCircledIcon';
export { default as AssignmentCompleteIcon } from './learning_circled/AssignmentCompleteIcon';
export { default as AssignmentErrorIcon } from './learning_circled/AssignmentErrorIcon';
export { default as CertificateCircledIcon } from './learning_circled/CertificateCircledIcon';
export { default as DialogueCircledIcon } from './learning_circled/DialogueCircledIcon';
export { default as DiscussionPromptCircledIcon } from './learning_circled/DiscussionPromptCircledIcon';
export { default as GradingCircledIcon } from './learning_circled/GradingCircledIcon';
export { default as HonorsAssignmentCircledIcon } from './learning_circled/HonorsAssignmentCircledIcon';
export { default as LTICircledIcon } from './learning_circled/LTICircledIcon';
export { default as LockCircledIcon } from './learning_circled/LockCircledIcon';
export { default as NoteCircledIcon } from './learning_circled/NoteCircledIcon';
export { default as ProgrammingAssignmentCircledIcon } from './learning_circled/ProgrammingAssignmentCircledIcon';
export { default as QuizCircledIcon } from './learning_circled/QuizCircledIcon';
export { default as ReadingCircledIcon } from './learning_circled/ReadingCircledIcon';
export { default as ReviewCircledIcon } from './learning_circled/ReviewCircledIcon';
export { default as SlideshowCircledIcon } from './learning_circled/SlideshowCircledIcon';
export { default as StaffGradedCircledIcon } from './learning_circled/StaffGradedCircledIcon';
export { default as VideoCircledIcon } from './learning_circled/VideoCircledIcon';
export { default as WebCircledIcon } from './learning_circled/WebCircledIcon';

// media

export { default as ClosedCaptioningIcon } from './media/ClosedCaptioningIcon';
export { default as FullscreenIcon } from './media/FullscreenIcon';
export { default as FullscreenExitIcon } from './media/FullscreenExitIcon';
export { default as MicrophoneIcon } from './media/MicrophoneIcon';
export { default as PauseIcon } from './media/PauseIcon';
export { default as PlayIcon } from './media/PlayIcon';
export { default as SkipBackIcon } from './media/SkipBackIcon';
export { default as SkipForwardIcon } from './media/SkipForwardIcon';
export { default as StopIcon } from './media/StopIcon';
export { default as StopFilledIcon } from './media/StopFilledIcon';
export { default as VideoPlayIcon } from './media/VideoPlayIcon';
export { default as VolumeLowIcon } from './media/VolumeLowIcon';
export { default as VolumeMaxIcon } from './media/VolumeMaxIcon';
export { default as VolumeMuteIcon } from './media/VolumeMuteIcon';

// navigation

export { default as BellIcon } from './navigation/BellIcon';
export { default as ExternalLinkIcon } from './navigation/ExternalLinkIcon';
export { default as FilterIcon } from './navigation/FilterIcon';
export { default as FolderIcon } from './navigation/FolderIcon';
export { default as GlobeIcon } from './navigation/GlobeIcon';
export { default as HelpIcon } from './navigation/HelpIcon';
export { default as HomeIcon } from './navigation/HomeIcon';
export { default as MenuIcon } from './navigation/MenuIcon';
export { default as MenuSwitcherIcon } from './navigation/MenuSwitcherIcon';
export { default as MoreActionsIcon } from './navigation/MoreActionsIcon';
export { default as ProfileIcon } from './navigation/ProfileIcon';
export { default as SearchIcon } from './navigation/SearchIcon';
export { default as SettingsIcon } from './navigation/SettingsIcon';
export { default as SignOutIcon } from './navigation/SignOutIcon';
export { default as SplitScreenIcon } from './navigation/SplitScreenIcon';
export { default as TranslationIcon } from './navigation/TranslationIcon';

// rich_text

export { default as AddColumnIcon } from './rich_text/AddColumnIcon';
export { default as AddRowIcon } from './rich_text/AddRowIcon';
export { default as AttachmentIcon } from './rich_text/AttachmentIcon';
export { default as BoldIcon } from './rich_text/BoldIcon';
export { default as BulletListIcon } from './rich_text/BulletListIcon';
export { default as CodeIcon } from './rich_text/CodeIcon';
export { default as IndentLessIcon } from './rich_text/IndentLessIcon';
export { default as IndentMoreIcon } from './rich_text/IndentMoreIcon';
export { default as InsertImageIcon } from './rich_text/InsertImageIcon';
export { default as InsertMathIcon } from './rich_text/InsertMathIcon';
export { default as ItalicsIcon } from './rich_text/ItalicsIcon';
export { default as LinkIcon } from './rich_text/LinkIcon';
export { default as MentionIcon } from './rich_text/MentionIcon';
export { default as MonospaceIcon } from './rich_text/MonospaceIcon';
export { default as NumberedListIcon } from './rich_text/NumberedListIcon';
export { default as ParagraphIcon } from './rich_text/ParagraphIcon';
export { default as PluginIcon } from './rich_text/PluginIcon';
export { default as QuoteIcon } from './rich_text/QuoteIcon';
export { default as RemoveColumnIcon } from './rich_text/RemoveColumnIcon';
export { default as RemoveRowIcon } from './rich_text/RemoveRowIcon';
export { default as RulerIcon } from './rich_text/RulerIcon';
export { default as SubscriptIcon } from './rich_text/SubscriptIcon';
export { default as SuperscriptIcon } from './rich_text/SuperscriptIcon';
export { default as TableIcon } from './rich_text/TableIcon';
export { default as UnderlineIcon } from './rich_text/UnderlineIcon';
export { default as UnlinkIcon } from './rich_text/UnlinkIcon';
export { default as VerticalAlignBottomIcon } from './rich_text/VerticalAlignBottomIcon';
export { default as VerticalAlignMiddleIcon } from './rich_text/VerticalAlignMiddleIcon';
export { default as VerticalAlignTopIcon } from './rich_text/VerticalAlignTopIcon';

// status

export { default as AIGenerateIcon } from './status/AIGenerateIcon';
export { default as AIGenerateBrandedIcon } from './status/AIGenerateBrandedIcon';
export { default as ErrorIcon } from './status/ErrorIcon';
export { default as InformativeIcon } from './status/InformativeIcon';
export { default as SuccessIcon } from './status/SuccessIcon';
export { default as WarningIcon } from './status/WarningIcon';

// toggles

export { default as BookmarkIcon } from './toggles/BookmarkIcon';
export { default as BookmarkFilledIcon } from './toggles/BookmarkFilledIcon';
export { default as FlagIcon } from './toggles/FlagIcon';
export { default as FlagFilledIcon } from './toggles/FlagFilledIcon';
export { default as StarIcon } from './toggles/StarIcon';
export { default as StarFilledIcon } from './toggles/StarFilledIcon';
export { default as StarHalfFilledIcon } from './toggles/StarHalfFilledIcon';
export { default as ThumbsDownIcon } from './toggles/ThumbsDownIcon';
export { default as ThumbsDownFilledIcon } from './toggles/ThumbsDownFilledIcon';
export { default as ThumbsUpIcon } from './toggles/ThumbsUpIcon';
export { default as ThumbsUpFilledIcon } from './toggles/ThumbsUpFilledIcon';

// actions

export { default as SpinnerIcon } from './actions/SpinnerIcon';

// communication

export { default as BoxIcon } from './communication/BoxIcon';
export { default as ReplyAllIcon } from './communication/ReplyAllIcon';
export { default as ReplyOutlinedIcon } from './communication/ReplyOutlinedIcon';

// content

export { default as CorrectAnswerIcon } from './content/CorrectAnswerIcon';
export { default as MultipleCorrectAnswersIcon } from './content/MultipleCorrectAnswersIcon';
export { default as QuestionBankIcon } from './content/QuestionBankIcon';
export { default as ReviewYourPeersIcon } from './content/ReviewYourPeersIcon';
export { default as TextBlockIcon } from './content/TextBlockIcon';

// devices

export { default as PhoneFailIcon } from './devices/PhoneFailIcon';
export { default as PhoneLandscapeIcon } from './devices/PhoneLandscapeIcon';
export { default as PrinterIcon } from './devices/PrinterIcon';

// editing

export { default as AlignLeftIcon } from './editing/AlignLeftIcon';
export { default as AlignMiddleIcon } from './editing/AlignMiddleIcon';
export { default as AlignRightIcon } from './editing/AlignRightIcon';
export { default as FontColorIcon } from './editing/FontColorIcon';
export { default as FontSizeIcon } from './editing/FontSizeIcon';
export { default as ImageCaptionIcon } from './editing/ImageCaptionIcon';
export { default as LargeGridIcon } from './editing/LargeGridIcon';
export { default as LayoutIcon } from './editing/LayoutIcon';
export { default as LineSpacingIcon } from './editing/LineSpacingIcon';
export { default as ListIcon } from './editing/ListIcon';
export { default as ListAltIcon } from './editing/ListAltIcon';
export { default as MiniplayerIcon } from './editing/MiniplayerIcon';
export { default as SectionBreakIcon } from './editing/SectionBreakIcon';
export { default as SmallGridIcon } from './editing/SmallGridIcon';
export { default as StrikethroughIcon } from './editing/StrikethroughIcon';
export { default as TableInsertColumnIcon } from './editing/TableInsertColumnIcon';
export { default as TableInsertRowIcon } from './editing/TableInsertRowIcon';
export { default as TableMergeCellsIcon } from './editing/TableMergeCellsIcon';
export { default as TypeIcon } from './editing/TypeIcon';
export { default as WrapBreakTextIcon } from './editing/WrapBreakTextIcon';
export { default as WrapInlineIcon } from './editing/WrapInlineIcon';
export { default as WrapTextIcon } from './editing/WrapTextIcon';

// education

export { default as GlobeOneIcon } from './education/GlobeOneIcon';
export { default as OpenBookIcon } from './education/OpenBookIcon';

// general

export { default as BackspaceIcon } from './general/BackspaceIcon';
export { default as DragHorzIcon } from './general/DragHorzIcon';
export { default as FlashIcon } from './general/FlashIcon';
export { default as HeartIcon } from './general/HeartIcon';
export { default as HeartFilledIcon } from './general/HeartFilledIcon';
export { default as LinkedItemIcon } from './general/LinkedItemIcon';
export { default as MoveIcon } from './general/MoveIcon';

// gestures

export { default as HandIcon } from './gestures/HandIcon';
export { default as HandFilledIcon } from './gestures/HandFilledIcon';
export { default as PointDownIcon } from './gestures/PointDownIcon';
export { default as PointDownFilledIcon } from './gestures/PointDownFilledIcon';
export { default as PointNextIcon } from './gestures/PointNextIcon';
export { default as PointNextFilledIcon } from './gestures/PointNextFilledIcon';
export { default as PointPreviousIcon } from './gestures/PointPreviousIcon';
export { default as PointPreviousFilledIcon } from './gestures/PointPreviousFilledIcon';
export { default as PointerUpIcon } from './gestures/PointerUpIcon';
export { default as PointerUpFilledIcon } from './gestures/PointerUpFilledIcon';

// graphs

export { default as BarChartOneIcon } from './graphs/BarChartOneIcon';
export { default as BarChartOneFillIcon } from './graphs/BarChartOneFillIcon';
export { default as BarChartThreeFillIcon } from './graphs/BarChartThreeFillIcon';
export { default as BarChartTwoIcon } from './graphs/BarChartTwoIcon';
export { default as BarChartTwoFillIcon } from './graphs/BarChartTwoFillIcon';
export { default as LineChartIcon } from './graphs/LineChartIcon';
export { default as PieChartIcon } from './graphs/PieChartIcon';
export { default as PieChartThreeDIcon } from './graphs/PieChartThreeDIcon';

// location

export { default as DirectionIcon } from './location/DirectionIcon';
export { default as PinIcon } from './location/PinIcon';

// media

export { default as AirPlayIcon } from './media/AirPlayIcon';
export { default as FastForwardIcon } from './media/FastForwardIcon';
export { default as RecordIcon } from './media/RecordIcon';
export { default as RepeatIcon } from './media/RepeatIcon';
export { default as RewindIcon } from './media/RewindIcon';
export { default as ShuffleIcon } from './media/ShuffleIcon';
export { default as VideoEditingIcon } from './media/VideoEditingIcon';
export { default as VideoOneIcon } from './media/VideoOneIcon';

// photos

export { default as CameraIcon } from './photos/CameraIcon';

// purchasing

export { default as DiscountIcon } from './purchasing/DiscountIcon';

// ratings

export { default as CropIcon } from './ratings/CropIcon';
export { default as SmileIcon } from './ratings/SmileIcon';
export { default as StarFilledColoredBoldIcon } from './ratings/StarFilledColoredBoldIcon';
export { default as StarHalfFilledColoredBoldIcon } from './ratings/StarHalfFilledColoredBoldIcon';

// rhyme

export { default as AddCloudDesktopIcon } from './rhyme/AddCloudDesktopIcon';
export { default as ColumnSettingsIcon } from './rhyme/ColumnSettingsIcon';
export { default as ControllingIcon } from './rhyme/ControllingIcon';
export { default as DescriptionIcon } from './rhyme/DescriptionIcon';
export { default as FocusIcon } from './rhyme/FocusIcon';
export { default as FrownIcon } from './rhyme/FrownIcon';
export { default as MinusFifteenSecBackIcon } from './rhyme/MinusFifteenSecBackIcon';
export { default as NewRecordingIcon } from './rhyme/NewRecordingIcon';
export { default as OthersIcon } from './rhyme/OthersIcon';
export { default as PreloaderIcon } from './rhyme/PreloaderIcon';
export { default as SavedIcon } from './rhyme/SavedIcon';
export { default as SavingVMHalfFullIcon } from './rhyme/SavingVMHalfFullIcon';
export { default as SavingVMQuarterFullIcon } from './rhyme/SavingVMQuarterFullIcon';
export { default as ScreenshotIcon } from './rhyme/ScreenshotIcon';

// signs

export { default as ForkIcon } from './signs/ForkIcon';
export { default as SyncIcon } from './signs/SyncIcon';
export { default as WarningFilledIcon } from './signs/WarningFilledIcon';
export { default as WifiIcon } from './signs/WifiIcon';
export { default as WifiOffIcon } from './signs/WifiOffIcon';

// time

export { default as ClockFilledIcon } from './time/ClockFilledIcon';

import data from './iconsMap.json';

export const iconsMap = data;
